<div class="col-12 mb-4">
  <form 
    class="row"
    [id]="timetable ? timetable.timetableId : 'formTimetable'" 
    [formGroup]="formTimetable!" 
    (ngSubmit)="onSubmit()">

    <div class="col-6 col-md-6 col-lg-2 col-xl col-lg mb-3 mb-lg-0">
      <span class="mb-2 d-block d-lg-none">Inicio</span>
      <p-calendar 
        inputId="calendar-timeonly" 
        formControlName="startHour"
        dateFormat="hh:mm"
        [timeOnly]="true" />
    </div>

    <div class="col-6 col-md-6 col-lg-2 col-xl col-lg mb-3 mb-lg-0">
      <span class="mb-2 d-block d-lg-none">Fin</span>
      <p-calendar 
        inputId="calendar-timeonly" 
        formControlName="endHour"
        dateFormat="hh:mm"
        [timeOnly]="true" />
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="monday"
          id="monday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="monday">
          Lunes
        </label>
      </div>
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="tuesday"
          id="tuesday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="tuesday">
          Martes
        </label>
      </div>
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="wednesday"
          id="wednesday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="wednesday">
          Miércoles
        </label>
      </div>
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="thursday"
          id="thursday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="thursday">
          Jueves
        </label>
      </div>
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="friday"
          id="friday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="friday">
          Viernes
        </label>
      </div>
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="saturday"
          id="saturday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="saturday">
          Sábado
        </label>
      </div>
    </div>

    <div class="col-12 col-md-3 col-lg text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="sunday"
          id="sunday" />
        <label 
          class="form-check-label d-block d-lg-none" 
          for="sunday">
          Domingo
        </label>
      </div>
    </div>

    <div class="col-12 col-xl text-md-center mb-3 mb-lg-0 d-flex justify-content-center align-items-center">
      <button
          type="button"
          (click)="onSubmit()"
          class="btn btn-sm btn-success rounded-circle d-flex align-items-center justify-content-center"
          style="width: calc(1.4rem + 1.4vh); height: calc(1.4rem + 1.4vh);"
          placement="top" 
          [ngbTooltip]="
            timetable ? 'Guardar' : 'Registrar'">
          <i class="material-icons"><small>
            @if(timetable) {
              save
            } @else {
              add
            }
          </small></i>
        </button>

        @if(timetable) {
          <button
            type="button"
            (click)="delete()"
            class="btn btn-sm btn-danger rounded-circle d-flex align-items-center justify-content-center ms-2"
            style="width: calc(1.4rem + 1.4vh); height: calc(1.4rem + 1.4vh);"
            placement="top" 
            [ngbTooltip]="'Eliminar'">
            <i class="material-icons"><small>delete</small></i>
          </button>
        }
    </div>

  </form>
</div>